import type { ValueOf } from '@vy/utils';
import { oz } from '@vy/utils';
import type { Control } from 'react-hook-form';
import { InvoiceNumberSyncStrategySchema } from '@vy/integrations-types';

export const SYNC_DIRECTIONS = Object.freeze({
  SYNC_FROM_VAYU: 'sync-from-vayu',
  SYNC_TO_VAYU: 'sync-to-vayu',
  AUTO_SYNC_DISABLED: 'auto-sync-disabled',
});

export type SyncDirection = ValueOf<typeof SYNC_DIRECTIONS>;

export const MorningConfigurationFormSchema = oz.object({
  apiKey: oz.string(),
  secretId: oz.string(),
  syncApprovedInvoices: oz.boolean().optional(),
  syncCustomer: oz.nativeEnum(SYNC_DIRECTIONS).optional(),
  invoiceNumberSyncStrategy: InvoiceNumberSyncStrategySchema.optional(),
});

export type MorningConfigurationFormValues = oz.infer<typeof MorningConfigurationFormSchema>;
export type MorningConfigurationControl = Control<MorningConfigurationFormValues>;
